import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import ViewAllAccountsListItem from './ViewAllAccountsListItem';

const ViewAllAccountsListItemPicker = ({ lineItemResource, ...rest }) => {
  return pickFunction(lineItemResource, {
    [fr.relationships.institution.name]: () => {
      return (
        <ViewAllAccountsListItem
          lineItemResource={lineItemResource}
          {...rest}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default ViewAllAccountsListItemPicker;
